export const PetType = {
  Dog: 'dog',
  Cat: 'cat',
} as const;
